module.exports = __webpack_public_path__ + "img/hm_block02_tc.76966387.jpg";